import './footer.css';
import { Button, Footer, Link } from '@efast_public/fjd-component-library';
import { useEffect, useState } from 'react';
import FooterDto, { FooterType } from '../../api/models/Footer/FooterDto';
import { defaultFooterLinks } from './defaultFooterLinks';
import useConfigurationStep, {
  ConfigurationStep
} from '../../api/hooks/useConfigurationStep';
import { useQuery } from '@tanstack/react-query';
import { BehApiRoutes, behBaseFooterUrl, behClient } from '../../api/beh-api';
import { useNotification } from '../../shared/notification/useNotification';

export function BehFooter() {
  const { notifyUserFromRequest } = useNotification();
  const { data: footers, error } = useQuery<Array<FooterDto>, Error>({
    queryKey: [BehApiRoutes.footer()],
    queryFn: () =>
      notifyUserFromRequest(() =>
        behClient.get(behBaseFooterUrl + BehApiRoutes.footer())
      )
  });
  const [footer, setFooter] = useState<Array<FooterDto>>(defaultFooterLinks);
  const { configurationStep } = useConfigurationStep();

  useEffect(() => {
    if (!error && footers && footers.length > 0) {
      setFooter(sortFooterLinksByFooterType(footers));
    }
  }, [footers, error]);

  const sortFooterLinksByFooterType = (
    footers: Array<FooterDto>
  ): Array<FooterDto> => {
    return Array.isArray(footers)
      ? [...footers].sort((a: FooterDto, b: FooterDto) => {
          const getPriority = (footerType?: FooterType) =>
            footerType === 'LEGAL' ? 0 : 1;
          return getPriority(a.footerType) - getPriority(b.footerType);
        })
      : [];
  };

  const footerAvailable: boolean = true;

  if (!footerAvailable) {
    return <></>;
  }

  return (
    <Footer
    //Temporary fix for footer
    // after={<div>{version}</div>}
    >
      {footer.map((link) => (
        <Link key={link.title} href={link.url}>
          {link.title}
        </Link>
      ))}
    </Footer>
  );
}
